const localState = {
    pdf: {},
    list: null,
    isActive: 'main',
    isShowModal: false,
}

const mutations = {
    setState: (state, {
        key,
        data,
    }) => {
        state[key] = data
    },
}

const actions = {
    async fetch({
        commit,
    }) {
        const response = await this.$api.pdf.fetch()
        commit('setState', {
            key: 'list',
            data: response.data.data || [],
        })
    },

    async generate(_, form) {
        return await this.$api.pdf.generate(form)
    },

    async sendEmail(_, data) {
        return await this.$api.pdf.sendEmail(data)
    },

    async remove(_, id) {
        return await this.$api.pdf.remove(id)
    },
}

const getters = {
    pdf: (state) => state.pdf,
    list: (state) => state.list,
    isActive: (state) => state.isActive,
    isShowModal: (state) => state.isShowModal,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
